module.exports = __webpack_public_path__ + "static/img/08.be77b24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/raz_frauenfeld/08.jpg
// module id = 447
// module chunks = 1